var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('multiselect',_vm._g(_vm._b({},'multiselect',_vm.$attrs,false),_vm.$listeners)),_c('div',{staticClass:"px-3"},[_c('error-message',{attrs:{"valid":_vm.success,"error-messages":_vm.errorMessages}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }